module.exports = __webpack_public_path__ + "img/fmale.3db605db.png";